import React, { forwardRef } from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { animations } from "helpers/animations";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import RegularButton from "components/CustomButtons/Button";
import { useThemeMode } from "hooks/useThemeMode";
import { darkPalette } from "helpers/themeColors";

// Los consumidores pasan estilos como props sueltas (maxWidth, padding, textAlign...);
// solo se reenvían al style las de esta lista, para que otras props no se vuelvan estilos.
const STYLE_PROPS = ["maxWidth", "minHeight", "padding", "textAlign"];

const pickStyleProps = (props) =>
  Object.fromEntries(
    STYLE_PROPS.filter((key) => props[key] !== undefined).map((key) => [key, props[key]])
  );

export const ConfirmModal = forwardRef((props, _) => {
  const {
    children,
    title,
    isLoading = false,
    loading = false,
    submitButtons = false,
    onClose,
    onSubmit = null,
    disabledBtn = false,
    confirmText = "Confirmar",
    confirmColor = "info",
    style: styleProp = {},
  } = props;

  const { isDark } = useThemeMode();

  return (
    <>
      <Box
        className={animations.fadeIn}
        tabIndex={-1}
        style={{
          borderRadius: 8,
          padding: 40,
          backgroundColor: isDark ? darkPalette.cardBg : "#fff",
          color: isDark ? darkPalette.textPrimary : "inherit",
          position: "relative",
          ...pickStyleProps(props),
          ...styleProp,
        }}
      >
        <Typography
          component="h2"
          variant="h5"
          color="primary"
          style={{ marginBottom: 45, textAlign: "center" }}
        >
          {title}
        </Typography>
        <Grid container spacing={2}>
          {children}
          {submitButtons ||
            (onSubmit && (
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 32,
                }}
              >
                <RegularButton
                  color="transparent"
                  onClick={onClose}
                  disabled={isLoading || loading}
                >
                  Cancelar
                </RegularButton>
                <RegularButton
                  color={confirmColor}
                  onClick={onSubmit}
                  disabled={disabledBtn}
                  loading={isLoading || loading}
                >
                  {confirmText}
                </RegularButton>
              </Grid>
            ))}
        </Grid>
      </Box>
    </>
  );
});
